"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const DocumentDetailWrapper = styled_components_1.default.div `
  height: 92vh;
  overflow: hidden;
  position: relative;
  embed {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
`;
const PdfTitle = styled_components_1.default.div `
  text-align: center;
  width: 100%;
  padding: 24px;
  font-size: 1rem;
`;
const PdfButtonWrapper = styled_components_1.default.div `
  width: 50%;
  margin: 0 auto 24px auto;
`;
const DocumentDetail = (props) => {
    const showPdf = () => window.open(props.documentData.dataUrl, "_blank");
    return (react_1.default.createElement(DocumentDetailWrapper, { className: "document-page" },
        react_1.default.createElement(PdfTitle, null, props.documentData.title),
        react_1.default.createElement(PdfButtonWrapper, null,
            react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", onClick: showPdf }, i18n_js_1.default.t("open")))));
};
exports.default = DocumentDetail;
